import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import { IFlowData } from 'src/components/ui/Form/types';

import { IMerchant } from '../merchants/types';

import { ICreateUser, IUser } from './types';

export const fetchUsersListRequest = async ({ page, size, ...data }: IFlowData): Promise<IUser[] | null> => {
  try {
    const res = await axios.post('api/v1/admin-users/search', data);
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch users");
    return null;
  }
};

export const fetchUserByIdRequest = async (id: string): Promise<IUser | null> => {
  try {
    const res = await axios.get(`api/v1/admin-users/${id}`);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't fetch user ${id}`);
    return null;
  }
};

export const createUserRequest = async (data: ICreateUser): Promise<void> => {
  return axios.post('api/v1/admin-users', data);
};

export const setUserPasswordRequest = async (data: IFlowData): Promise<void> => {
  return axios.post('api/v1/admin-users/restore/password', data);
};

export const recoverUserPasswordRequest = async (params: IFlowData): Promise<void> => {
  return axios.get('api/v1/admin-users/restore/password', { params });
};

export const changeUserEmailRequest = async ({ password: currentPassword, email }: IFlowData): Promise<void> => {
  return axios.put('api/v1/admin-users/email', { currentPassword, email });
};

export const changeUserPasswordRequest = async ({ currentPassword, newPassword }: IFlowData): Promise<void> => {
  return axios.put('api/v1/admin-users/password', { currentPassword, newPassword });
};

export const confirmUserEmailRequest = async (id: string): Promise<void> => {
  return axios.get(`api/v1/admin-users/confirmation-email/${id}`);
};

export const updateUserRequest = async ({ id, email, status, merchants, role }: IFlowData): Promise<void> => {
  return axios.put(`api/v1/admin-users/${id}`, {
    email,
    status: status?.value,
    merchantIds: merchants?.map((merchant: IMerchant) => merchant.id),
    role: role?.value,
  });
};

export const resendActivationLink = async (id: number) => {
  try {
    const response = await axios.get(`api/v1/admin-users/${id}/confirmation-email/send`);

    NotificationManager.success('The letter was sent by email');

    return response;
  } catch (e) {
    NotificationManager.error('The letter was not sent');
  }
};
